import { request } from './service'

/**
 * 创建 Stripe Checkout Session
 * @param {string} plan - 套餐类型: pro | enterprise | interview | persona | report
 * @param {string} billingType - 计费周期: monthly | yearly（仅订阅套餐有效）
 * @returns {Promise<{code: number, data: {url: string}, msg: string}>}
 */
export function createCheckoutSession(plan, billingType) {
  return request({
    url: 'payment/create-checkout-session/',
    method: 'post',
    data: { plan, billing_type: billingType }
  })
}

/**
 * 查询当前用户订阅状态
 * @returns {Promise<{code: number, data: {plan, billing_type, status, current_period_end}, msg: string}>}
 */
export function getSubscription() {
  return request({
    url: 'payment/subscription/',
    method: 'get'
  })
}

/**
 * 创建 Stripe Customer Portal Session（订阅管理/取消）
 * @returns {Promise<{code: number, data: {url: string}, msg: string}>}
 */
export function createPortalSession() {
  return request({
    url: 'payment/create-portal-session/',
    method: 'post'
  })
}
